import React, { useEffect, useState } from "react";
import api from "../../../utils/axios";
import { getAlert, useEscapeClose } from "../../../utils/SamuiUtils";

export default function FileModalAppointment({
  mode = "E",
  showViewAttachModal,
  setShowViewAttachModal,
  selectedFiles,
  setSelectedFiles,
  Appoint_Id,
  ServiceAddr_Id,
}) {
  const [showFilePreview, setShowFilePreview] = useState(false);
  const [currentPreviewFile, setCurrentPreviewFile] = useState(null);
  const [coverFileId, setCoverFileId] = useState(null);
  const [hadFilesFromDB, setHadFilesFromDB] = useState(false);

  useEscapeClose(showViewAttachModal, () => setShowViewAttachModal(false));
  useEscapeClose(showFilePreview, () => setShowFilePreview(false));

  // ⭐ Reset hadFilesFromDB เมื่อปิด modal
  useEffect(() => {
    if (!showViewAttachModal) {
      setHadFilesFromDB(false);
    }
  }, [showViewAttachModal]);

  useEffect(() => {
    const fetchFiles = async () => {
      if (!showViewAttachModal || !Appoint_Id) return;
      try {
        const res = await api.get(`/get-appoint-files/${Appoint_Id}`);
        if (
          res.data.status === "OK" &&
          Array.isArray(res.data.result?.recordsets?.[0])
        ) {
          const files = res.data.result.recordsets[0].map((f) => ({
            File_Id: f.File_Id,
            File_Url: decodeURI(f.FilePath),
            File_Name: f.FileName,
            type: f.FileType || "",
            size: f.FileSize || 0,
            IsCover: f.IsCover === true || f.IsCover === 1,
          }));
          setSelectedFiles(files);
          // ⭐ Track ว่ามีไฟล์จาก DB หรือไม่
          if (files.length > 0) {
            setHadFilesFromDB(true);
          } else {
            setHadFilesFromDB(false);
          }
        } else {
          setSelectedFiles([]);
          setHadFilesFromDB(false);
        }
      } catch (err) {
        getAlert("FAILED", "โหลดไฟล์ไม่สำเร็จ");
        setHadFilesFromDB(false);
      }
    };
    fetchFiles();
  }, [showViewAttachModal, Appoint_Id]);

  // ⭐ Auto browse เมื่อไม่มีไฟล์ (แต่ไม่เด้งถ้าเคยมีไฟล์จาก DB แล้วลบจนเหลือ 0)
  useEffect(() => {
    if (showViewAttachModal && selectedFiles.length === 0 && !hadFilesFromDB) {
      const timer = setTimeout(() => {
        const input = document.getElementById("file-upload-appoint");
        if (input) input.click();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [showViewAttachModal, selectedFiles, hadFilesFromDB]);


  const handleFileSelection = async (event) => {
    const files = Array.from(event.target.files);

    // ⭐ ถ้าผู้ใช้กด cancel และไม่มีไฟล์ใน modal ให้ปิด modal เลย
    if (!files.length) {
      if (selectedFiles.length === 0) {
        setShowViewAttachModal(false);
      }
      return;
    }

    const formData = new FormData();
    files.forEach((f) => formData.append("files", f));
    formData.append("Comp_Id", 1);
    formData.append("ServiceAddr_Id", ServiceAddr_Id);
    formData.append("Appoint_Id", Appoint_Id);

    try {
      const res = await api.post(
        `/upload-appoint-file/${Appoint_Id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.status === "OK") {
        const refresh = await api.get(`/get-appoint-files/${Appoint_Id}`);
        if (refresh.data.status === "OK") {
          const updated = refresh.data.result.recordset.map((f) => ({
            File_Id: f.File_Id,
            File_Url: decodeURI(f.FilePath),
            File_Name: f.FileName,
            type: f.FileType || "",
            size: f.FileSize || 0,
            IsCover: f.IsCover === 1,
          }));
          setSelectedFiles(updated);
        }
      } else {
        getAlert("FAILED", res.data.message || "อัปโหลดไม่สำเร็จ");
      }
    } catch (err) {
      getAlert("FAILED", "ไม่สามารถอัปโหลดไฟล์ได้");
    }
  };


  const handleDeleteFile = async (fileId) => {
    try {
      const res = await api.delete(`/delete-appoint-file/${fileId}`);
      if (res.data.status === "OK") {
        setSelectedFiles((prev) => prev.filter((f) => f.File_Id !== fileId));
        if (fileId === coverFileId) {
          setCoverFileId(null);
        }
      } else getAlert("FAILED", "ลบไฟล์ไม่สำเร็จ");
    } catch (err) {
      getAlert("FAILED", "ไม่สามารถลบไฟล์ได้");
    }
  };

  const handlePreviewFile = (file) => {
    setCurrentPreviewFile(file);
    setShowFilePreview(true);
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return "0 KB";
    const kb = bytes / 1024;
    return kb < 1024 ? `${kb.toFixed(1)} KB` : `${(kb / 1024).toFixed(1)} MB`;
  };

  const handleSetCover = async (fileId) => {
    try {
      const res = await api.put(`/set-appoint-cover/${fileId}`, {
        ServiceAddr_Id,
      });
      if (res.data.status === "OK") {
        setCoverFileId(fileId);
        setSelectedFiles((prev) =>
          prev.map((f) => ({
            ...f,
            IsCover: f.File_Id === fileId,
          }))
        );
      } else {
        getAlert("FAILED", res.data.message);
      }
    } catch (err) {
      getAlert("FAILED", "ตั้งรูปหน้าปกไม่สำเร็จ");
    }
  };

  const handleDownload = async (file) => {
    try {
      const response = await fetch(file.File_Url);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = file.File_Name || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download error", err);
      getAlert("FAILED", "ไม่สามารถดาวน์โหลดไฟล์ได้");
    }
  };


  if (!showViewAttachModal) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 z-[4000] flex items-center justify-center"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="bg-white w-full max-w-5xl rounded-lg shadow-lg overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d-flex justify-content-between align-items-center px-4 py-2 border-bottom">
          <h5 className="modal-title">
            <i className="fa fa-paperclip me-2"></i>ไฟล์แนบนัดหมาย
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowViewAttachModal(false)}
          ></button>
        </div>

        <div
          className="px-4 py-3"
          style={{ maxHeight: "80vh", overflowY: "auto" }}
        >
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h6 className="mb-0 fw-semibold">
              <i className="fa fa-folder me-2"></i>เอกสารแนบนัดหมายทั้งหมด
            </h6>

            {mode !== "S" && (
              <>
                <input
                  type="file"
                  multiple
                  onChange={handleFileSelection}
                  style={{ display: "none" }}
                  id="file-upload-appoint"
                />
                <button
                  className="btn text-white"
                  style={{
                    backgroundColor: "rgb(239,108,0)",
                    borderRadius: "8px",
                    padding: "10px 20px",
                  }}
                  onClick={() =>
                    document.getElementById("file-upload-appoint").click()
                  }
                >
                  <i className="fa fa-plus me-2"></i>แนบไฟล์
                </button>
              </>
            )}
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
              gap: "20px",
            }}
          >
            {selectedFiles.length === 0 ? (
              <div className="text-center py-5 col-span-full">
                <i className="fa fa-folder-open fa-3x text-muted mb-3"></i>
                <p className="text-secondary">ไม่มีไฟล์แนบ</p>
              </div>
            ) : (
              selectedFiles.map((file, index) => (
                <div
                  key={file.File_Id || index}
                  className="border rounded-lg shadow-sm text-center p-3 position-relative bg-white"
                >
                  <button
                    className="btn btn-sm position-absolute top-0 end-0 m-2 rounded-circle"
                    onClick={() => handleSetCover(file.File_Id)}
                    style={{
                      backgroundColor: "rgba(255,255,255,0.9)",
                      border: "1px solid #ccc",
                      width: "30px",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="fa fa-star"
                      style={{
                        color: file.IsCover ? "#f7c600" : "#ddd",
                        fontSize: "16px",
                        filter: file.IsCover
                          ? "drop-shadow(0 0 3px #f7c600)"
                          : "none",
                      }}
                    ></i>
                  </button>

                  <button
                    onClick={() => handleDeleteFile(file.File_Id)}
                    className="btn btn-sm btn-danger position-absolute top-0 start-0 m-2 rounded-circle"
                  >
                    <i className="fa fa-times"></i>
                  </button>

                  <div
                    className="d-flex align-items-center justify-content-center bg-light rounded mb-2"
                    style={{
                      height: "100px",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => handlePreviewFile(file)}
                  >
                    {file.type.startsWith("image/") ? (
                      <img
                        src={file.File_Url}
                        alt={file.File_Name}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "cover",
                          borderRadius: "6px",
                        }}
                      />
                    ) : (
                      <i
                        className="fa fa-file"
                        style={{ fontSize: "36px", color: "#666" }}
                      ></i>
                    )}
                  </div>

                  <div
                    className="fw-semibold small text-truncate mb-1"
                    title={file.File_Name}
                  >
                    {file.File_Name}
                  </div>

                  <div className="text-muted small mb-2">
                    {formatFileSize(file.size)}
                  </div>

                  <div className="d-flex justify-content-center gap-2">
                    <button
                      className="btn btn-sm"
                      style={{
                        backgroundColor: "rgb(239, 108, 0)",
                        color: "white",
                        padding: "4px 8px",
                        fontSize: "11px",
                        borderRadius: "6px",
                        border: "none",
                      }}
                      onClick={() => handlePreviewFile(file)}
                    >
                      <i className="fa fa-eye"></i> ดู
                    </button>

                    {!file.isNew && (
                      <button
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "#28a745",
                          color: "white",
                          padding: "4px 8px",
                          fontSize: "11px",
                          borderRadius: "6px",
                        }}
                        onClick={() => handleDownload(file)}
                      >
                        <i className="fa fa-download"></i> โหลด
                      </button>


                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {showFilePreview && currentPreviewFile && (
        <div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-[5000]"
          onClick={() => setShowFilePreview(false)}
        >
          <div
            className="bg-white w-full max-w-5xl rounded-lg overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="d-flex justify-content-between align-items-center px-4 py-2 border-bottom">
              <h5 className="modal-title">
                <i className="fa fa-eye me-2"></i>ตัวอย่างไฟล์
              </h5>
              <button
                className="btn-close"
                onClick={() => setShowFilePreview(false)}
              ></button>
            </div>

            <div className="p-3 text-center">
              {currentPreviewFile.type.startsWith("image/") ? (
                <img
                  src={currentPreviewFile.File_Url}
                  alt={currentPreviewFile.File_Name}
                  className="img-fluid rounded"
                />
              ) : (
                <iframe
                  src={currentPreviewFile.File_Url}
                  width="100%"
                  height="600px"
                  title={currentPreviewFile.File_Name}
                ></iframe>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
